import { BaseApiClient } from "./base_api";

class ApiClient extends BaseApiClient {
  constructor(appApi = process.env.VUE_APP_PHP_API_URL) {
    super(appApi);
  }

  getCommunications(data) {
    return this.call(`communication`, "GET", data);
  }
  getLibrary(data) {
    return this.call(`libraries`, "GET", data);
  }
  getDownloadLibrary(id) {
    return this.call(`libraries/${id}`, "GET");
  }
  getFileDownload(id) {
    return this.call("files/download/" + id, "GET");
  }

  postAuthMe() {
    return this.call("auth/me", "POST", { with_permissions: true });
  }

  getCompany(domain) {
    return this.call("companies", "GET", { domain: domain });
  }
  getCoursesGroups(courseId) {
    return this.call(`courses/${courseId}/groups`, "GET", {
      module: [process.env.VUE_APP_API_MODULE],
    });
  }

  postCoursesGroups(courseId, data) {
    Object.assign(data, { module: process.env.VUE_APP_API_MODULE });
    return this.call(`courses/${courseId}/groups`, "POST", data);
  }

  getLgpdCoachings(data) {
    return this.call("coachings", "GET", data);
  }

  getLgpdCoachingReport(data) {
    if (localStorage.getItem("daily_report")) {
      return this.call("charts/coaching_reportv3", "GET", data);
    }
    return this.call("charts/coaching_report", "GET", data);
  }

  getReportsCourseReport(data) {
    return this.call("reports/course-report", "GET", data);
  }

  getLgpdCoachingLogindMoodle(id) {
    return this.call(`coachings/loginmoodle/${id}`, "GET");
  }

  archiveCourse(id) {
    return this.call(`courses/archive/${id}`, "GET");
  }

  restoreArchivedCourse(id) {
    return this.call(`courses/restore/${id}`, "GET");
  }
  // Document Groups
  getDocumentGroups(data) {
    return this.call("groups", "GET", {
      ...data,
      module: [process.env.VUE_APP_API_MODULE],
    });
  }

  // Document Groups
  getDocumentGroup(id) {
    return this.call(`groups/${id}`, "GET", {
      module: [process.env.VUE_APP_API_MODULE],
    });
  }

  deleteDocumentGroups(id) {
    return this.call(`groups/${id}`, "DELETE");
  }

  createDocumentGroups(data) {
    return this.call(`groups`, "POST", data);
  }

  updateDocumentGroup(id, data) {
    return this.call(`groups/${id}`, "PUT", data);
  }

  getDocumentGroupUsers(groupId) {
    return this.call(`groups/${groupId}/users`, "GET");
  }

  getDocumentGroupDocuments(groupId) {
    return this.call(`groups/${groupId}/documents`, "GET");
  }

  getDocumentGroupRoles(groupId) {
    return this.call(`groups/${groupId}/roles`, "GET");
  }

  //Course Groups
  getComplianceCouseGroups(data) {
    return this.call("course-groups", "GET", data);
  }
  getComplianceCouseGroup(id) {
    return this.call("course-groups/" + id, "GET");
  }
  postComplianceCouseGroup(data) {
    return this.call("course-groups/", "POST", data);
  }
  putComplianceCouseGroup(id, data) {
    return this.call("course-groups/" + id, "PUT", data);
  }
  deleteComplianceCouseGroup(id) {
    return this.call("course-groups/" + id, "DELETE");
  }

  postAuthLogin(data, company_id) {
    return this.call("auth/login?company_id=" + company_id, "POST", data);
  }

  postAuthResetHashVerify(data, company_id) {
    return this.call(
      "auth/reset-hash-verify?company_id=" + company_id,
      "POST",
      data,
    );
  }

  postAuthResetPassword(data, company_id) {
    return this.call(
      "auth/reset-password?company_id=" + company_id,
      "POST",
      data,
    );
  }

  postAuthNewPasswordHash(data, company_id) {
    return this.call(
      "auth/new-password-hash?company_id=" + company_id,
      "POST",
      data,
    );
  }

  postAuthRefresh() {
    return this.call("auth/refresh", "POST");
  }

  postAuthLogtOut() {
    return this.call("auth/logout", "POST");
  }

  putUserUpdatePassword(data) {
    return this.call("/users/updatepassword", "PUT", data);
  }

  putUserAccessibilityPreferences(data) {
    return this.call("/user-accessibility", "PUT", data);
  }

  putUserTermsOfUse() {
    return this.call("users/terms-of-use", "PUT");
  }

  getUsersDashboard(data) {
    return this.call("users/getCountsForDashboard", "GET");
  }

  getuser(id) {
    return this.call(`lgpd/responsibles/${id}`, "GET");
  }

  getUsers(data) {
    return this.call(`requests/users`, "GET", data);
  }

  getUserListProfiles() {
    return this.call(`requests/users/list-profiles`, "GET");
  }

  getDepartments(data) {
    return this.call("compliance-departments", "GET", data);
  }

  postFilesPreSignedUrl(data) {
    return this.call("files/pre-signed-url", "POST", data);
  }

  getLgpdFilesPreSignedUrl(data) {
    return this.call("files/pre-signed-url", "GET", data);
  }

  postPublictFilesPreSignedUrl(data) {
    return this.call("request/public/files/pre-signed-url", "POST", data);
  }

  getPublicFilesPreSignedUrl(data) {
    return this.call("request/public/files/pre-signed-url", "GET", data);
  }

  getFileDownload(id) {
    return this.call("files/download/" + id, "GET");
  }

  getReportProcess(id) {
    return this.call("reports/" + id, "GET");
  }

  getDataMappingDPIAReport(query) {
    return this.call("lgpd/data-mappings/dpia-report", "GET", query);
  }

  postUser(data) {
    data["modules"] = ["requests"];
    return this.call("requests/users", "POST", data);
  }
  putUser(id, data) {
    return this.call(`requests/users/${id}`, "PUT", data);
  }
  getRequestResponsible(data) {
    return this.call("requests/activities/responsibles", "GET", data);
  }

  getLgpdCoachings(data) {
    return this.call("lgpd/coachings", "GET", data);
  }

  //import user
  postImportUsers(data) {
    return this.call("import-users", "POST", data);
  }
  //user export
  getUserCsv(data) {
    return this.call("/user/export-user", "GET", data);
  }

  //private request
  getAllRequest(data) {
    return this.call("request", "GET", data);
  }
  postRequest(data) {
    return this.call("request", "POST", data);
  }
  putRequest(id, data) {
    return this.call("request/" + id, "PUT", data);
  }
  getRequest(id) {
    return this.call("request/" + id, "GET");
  }

  getRequestLogById(requestId, data) {
    return this.call(`request/log/${requestId}`, "GET", data);
  }

  //audit
  getAudit(data) {
    return this.call("audit", "GET", data);
  }
  getTypeRequest() {
    return this.call("request/request_types", "GET");
  }
  getTypeRequestWithModerators() {
    return this.call("requestTypes/getTequestTypes", "GET");
  }

  postImportRequests(data) {
    return this.call("request/import-requests", "POST", data);
  }

  getRequestsSubcategoriesType(id) {
    return this.call("request/request_subcategories/" + id, "GET");
  }

  getStatusRequest() {
    return this.call("request/request_status", "GET");
  }
  getRequestRelatory(type, data) {
    return this.call(`requests/export-requests/${type}`, "GET", data);
  }

  // Substatus
  getRequestsAllSubstatus(data) {
    return this.call("requests/substatus", "GET", data);
  }

  getRequestsSubstatusStatus(id) {
    return this.call("request/request_substatus/" + id, "GET");
  }

  getRequestsSubstatus(id) {
    return this.call("requests/substatus/" + id, "GET");
  }

  saveRequestsSubstatus(data) {
    return this.call("requests/substatus", "POST", data);
  }

  updateRequestsSubstatus(id, data) {
    return this.call("requests/substatus/" + id, "PUT", data);
  }

  deleteRequestsSubstatus(id) {
    return this.call("requests/substatus/" + id, "DELETE");
  }

  postRequestNote(data) {
    return this.call("request/note", "POST", data);
  }
  getReportRequestPdf(data) {
    return this.call("request/reports/request-report-pdf", "GET", data);
  }
  getReportRequestActivities(data) {
    return this.call("requests/activities/report-file", "GET", data);
  }
  getReportRequest(type, data) {
    return this.call(`request/reports/request-report/${type}`, "GET", data);
  }
  getReportRequestComplete(type, data) {
    return this.call(`request/reports/request-report-complete/${type}`, "GET", data);
  }
  getReportAllRequest(type, data) {
    return this.call(`request/activities/report/${type}`, "GET", data);
  }
  getTypeRequestOrigin() {
    return this.call("request/origins", "GET");
  }
  getResponsibleByOriginUsers(id) {
    return this.call("requestTypes/" + id + "/responsables", "GET");
  }
  saveResponsableByType(data, id) {
    return this.call("requestTypes/" + id + "/syncUsers", "POST", data);
  }
  saveResponsableByRequest(data, id) {
    return this.call("request/" + id + "/syncResponsables", "POST", data);
  }
  getResponsibleByRequest(id) {
    return this.call("request/" + id + "/responsables", "GET");
  }
  getResponsibleModerador() {
    return this.call("request/moderators", "GET");
  }
  saveResponsableModerador(data) {
    return this.call("request/moderators", "POST", data);
  }
  saveQuestionModerators(data) {
    return this.call("requests/questionModerators", "POST", data);
  }
  saveQuestionModeratorsConfig(data, id) {
    return this.call(`requests/questionModerators/${id}`, "PUT", data);
  }
  getQuestionModerators(id) {
    return this.call(`requests/questionModerators/${id}`, "GET");
  }
  deleteQuestionModerators(id, data) {
    return this.call(`requests/questionModerators/${id}`, "DELETE", data);
  }
  configComplianceModerator(data) {
    return this.call(`requests/changeCompanyModeratorStatus/`, "POST", data);
  }
  getModerators(data) {
    return this.call(`requests/questionModerators/`, "GET", data);
  }

  saveResponsableByQuestion(data, id) {
    return this.call(
      "requests/questionModerators/syncUsers/" + id,
      "POST",
      data,
    );
  }
  checkIfMissingConfig() {
    return this.call("request/verifyUnassingedRequests", "GET");
  }
  getAvailableUsers(data) {
    return this.call("request/getAvailableUsers", "POST", data);
  }
  getRequestsStats(data) {
    return this.call("request/stats", "GET", data);
  }
  putLocations(id, data) {
    return this.call(`requests/locations/${id}`, "PUT", data);
  }
  postLocations(data) {
    return this.call(`requests/locations`, "POST", data);
  }
  getLocations(data) {
    return this.call("requests/locations", "GET", data);
  }
  getAllLocationsText() {
    return this.call("requests/locations/getRequestsLocations", "GET");
  }

  getAllLocations(data) {
    data.noPaginate = true;
    return this.call("requests/locations", "GET", data);
  }

  deleteLocation(id, data) {
    return this.call(`requests/locations/${id}`, "DELETE", data);
  }
  getLocationLanguages(id = null) {
    return this.call(
      `requests/locations/getActiveLanguageCrudFields` + (id ? `/${id}` : ""),
      "GET",
    );
  }
  getRequestsParam(data) {
    return this.call("requests/configurations", "GET", data);
  }

  getRequestsConfigurationsLanguages(data) {
    return this.call("requests/configurationsLanguages", "GET", data);
  }

  saveRequestConfiguration(data) {
    return this.call("requests/configurations", "POST", data);
  }

  saveRequestLanguages(data) {
    return this.call("requests/configurationsLanguages", "POST", data);
  }

  saveRequestLanguageConfigs(data) {
    return this.call(
      "requests/configurationsLanguages/activeLang",
      "POST",
      data,
    );
  }

  getActiveLanguageCrudFields(type, id = null) {
    return this.call(
      `requests/configurationsLanguages/getActiveLanguageCrudFields/${type}` +
        (id ? `/${id}` : ""),
      "GET",
    );
  }

  getPublicRequestDisclaimer(companyUuid) {
    return this.call(
      "request/public/disclaimer/" + companyUuid,
      "GET",
      [],
      false,
      true,
    );
  }
  //open request
  getRequestTypes(data) {
    return this.call("request/request_types", "GET", data);
  }
  saveRequestsTypes(data) {
    return this.call("requests/requestTypes", "POST", data);
  }
  updateRequestsTypes(id, data) {
    return this.call("requests/requestTypes/" + id, "PUT", data);
  }
  postPublicRequest(data) {
    return this.call("request/public", "POST", data, false, true);
  }
  postPublicRequestFile(data) {
    return this.call("request/public/file", "POST", data, false, true);
  }
  postPublicRequestConsult(data) {
    return this.call("request/public/consult", "POST", data, false, true);
  }
  postSentRequest(data) {
    return this.call("request/public/sent_request", "POST", data, false, true);
  }
  postSentRequestFile(data) {
    return this.call(
      "request/public/sent_request/file",
      "POST",
      data,
      false,
      true,
    );
  }
  getPublicRequestCodeEthics(data) {
    return this.call("request/public/code-ethics", "GET", data, false, true);
  }
  getPublicRequestDisclaimer(companyUuid) {
    return this.call(
      "request/public/disclaimer/" + companyUuid,
      "GET",
      [],
      false,
      true,
    );
  }

  getPublicRequestLocations(companyUuid) {
    return this.call(
      "request/public/locations/" + companyUuid,
      "GET",
      [],
      false,
      true,
    );
  }
  getFormConfiguredQuestions() {
    return this.call(
      "requests/form-configured-questions",
      "GET",
      [],
      false,
      true,
    );
  }

  getRequestsPublicParam(companyUuid) {
    return this.call(
      "request/public/configuration/" + companyUuid,
      "GET",
      [],
      false,
      true,
    );
  }

  getRequestQuestions(data) {
    return this.call("requests/questions", "GET", data, false, true);
  }

  getRequestQuestion(id) {
    return this.call(`requests/questions/${id}`, "GET", [], false, true);
  }

  saveRequestConfigQuestions(data) {
    return this.call("requests/config-questions", "POST", data);
  }

  getRequestOrderQuestions() {
    return this.call("requests/order-questions", "GET");
  }

  saveRequestOrderQuestions(data) {
    return this.call("requests/order-questions", "POST", data);
  }

  // Subcategories
  getRequestsSubcategories(data) {
    return this.call("requests/subcategories", "GET", data);
  }

  getRequestsSubcategory(id) {
    return this.call("requests/subcategories/" + id, "GET");
  }

  saveRequestsSubcategory(data) {
    return this.call("requests/subcategories", "POST", data);
  }

  updateRequestsSubcategory(id, data) {
    return this.call("requests/subcategories/" + id, "PUT", data);
  }

  deleteRequestsSubcategory(id) {
    return this.call("requests/subcategories/" + id, "DELETE");
  }

  // Tags
  getRequestSearchTags() {
    return this.call("requests/data-search-tags", "GET");
  }

  saveDepartment(data) {
    return this.call("compliance-departments", "POST", data);
  }

  updateDepartment(id, data) {
    return this.call("compliance-departments/" + id, "PUT", data);
  }

  deleteDepartment(id) {
    return this.call("compliance-departments/" + id, "DELETE");
  }

  //ad groups
  getAdGroups(data) {
    return this.call("company-logins/ad-groups", "GET", data);
  }
  getEveryoneAdGroups(data) {
    return this.call("company-logins/ad-groups/all", "GET", data);
  }
  putAdGroups(id, data) {
    return this.call(`company-logins/ad-groups/${id}`, "PUT", data);
  }
  postAdGroupsUpdateMany(data) {
    return this.call(`company-logins/ad-groups/update-many`, "POST", data);
  }
  //company login
  getCompanyLogins(data) {
    return this.call("company-logins", "GET", data);
  }
  postCompanyLogins(type, data) {
    return this.call(`company-logins/${type}`, "POST", data);
  }
  putCompanyLoginDisableImport() {
    return this.call(`company-logins/disable-import`, "PUT", data);
  }
  putCompanyLoginImportData(type, data) {
    return this.call(`company-logins/import-data/${type}`, "PUT", data);
  }
  postProcessAdGroups(data) {
    return this.call("company-logins/process-ad-groups", "POST", data);
  }
  postProcessAdCompany(data) {
    return this.call("company-logins/process-ad-company", "POST", data);
  }
  getRequestsOpenedGraph(data) {
    return this.call("/charts/request_date", "GET", data);
  }
  getRequestsByTypesGraph(data) {
    return this.call("/charts/type_requests", "GET", data);
  }
  getRequestsStatusesGraph(data) {
    return this.call("/charts/status_requests", "GET", data);
  }
  getRequestsSubstatusGraph(data) {
    return this.call("/charts/substatus_requests", "GET", data);
  }
  getRequestsIdentifiedGraph(data) {
    return this.call("/charts/identified_requests", "GET", data);
  }
  getRequestsLocationsGraph(data) {
    return this.call("/charts/requests_units", "GET", data);
  }
  getRequestsTagsGraph(data) {
    return this.call("/request/stats-tags", "GET", data);
  }
  getRequestsSubcategoryGraph(data) {
    return this.call("/request/stats-subcategory", "GET", data);
  }
  getRequestsRiskGraph(data) {
    return this.call("/request/stats-risk", "GET", data);
  }
  deleteUser(id, data) {
    return this.call(`requests/users/${id}`, "DELETE", data);
  }
  anonimazeRequest(id, data) {
    return this.call("requests/anonimaze/" + id, "POST", data);
  }

  // Activities
  getRequestsActivities(data) {
    return this.call("requests/activities", "GET", data);
  }
  getAllRequestsActivities(data) {
    return this.call("requests/activities/list-all", "GET", data);
  }
  saveRequestsActivity(data) {
    return this.call("requests/activities", "POST", data);
  }
  updateRequestsActivity(id, data) {
    return this.call("requests/activities/" + id, "PUT", data);
  }
  saveRequestsNotes(data) {
    return this.call("requests/activities/notes", "POST", data);
  }
  updateRequestNotes(id, data) {
    return this.call("requests/activities/notes" + id, "PUT", data);
  }
  // Categories
  getCategories(data) {
    return this.call("/categories", "GET", data);
  }

  getCategory(id) {
    return this.call("/categories/" + id, "GET");
  }

  searchManuals(search) {
    return this.call("/manuals/search", "POST", search);
  }

  getManuals(id, data) {
    return this.call("/categories/" + id + "/manuals", "GET", data);
  }

  getManual(slug, module) {
    return this.call("/manuals/" + slug + "?module=" + module, "GET");
  }
  sendRequestNoteEmail(id) {
    return this.call("/request/resendNoteEmail/" + id, "GET");
  }
  changeNoteVisibility(id, data) {
    return this.call(`requests/changeNotesVisibleStatus/${id}`, "PUT", data);
  }
  //mensagens personalizadas
  getDefaultMessages(data) {
    return this.call("requests/notesDefaultMessages", "GET", {
      ...data,
      module: process.env.VUE_APP_API_MODULE,
    });
  }

  getDefaultMessage(id, data = {}) {
    return this.call("requests/notesDefaultMessages/" + id, "GET", {
      ...data,
      module: process.env.VUE_APP_API_MODULE,
    });
  }

  saveDefaultMessage(data) {
    return this.call("requests/notesDefaultMessages", "POST", {
      ...data,
      module: process.env.VUE_APP_API_MODULE,
    });
  }

  updateDefaultMessage(id, data) {
    return this.call("requests/notesDefaultMessages/" + id, "PUT", {
      ...data,
      module: process.env.VUE_APP_API_MODULE,
    });
  }

  getEmailConfigurations(data) {
    return this.call("configurations/getEmailConfiguration", "GET", data);
  }
  setConfigurations(data) {
    return this.call("configurations", "POST", data);
  }
  getConfigurations() {
    return this.call("configurations", "GET");
  }
  saveConfiguredEmail(data) {
    return this.call("configurations/configure_email", "POST", data);
  }
  resendWelcomeEmails(data) {
    return this.call("configurations/resend-welcome-emails", "POST", data);
  }

  changeRequestViewToType(id) {
    return this.call("requests/changeRequestViewToType/" + id, "POST");
  }

  saveEmailConfigs(data) {
    return this.call("configurations/save-email", "POST", data);
  }

  getEmailConfigs() {
    return this.call("configurations/email-configs", "GET");
  }

  createGroupsPerDepartments(data) {
    return this.call(
      "configurations/create-groups-per-departments",
      "POST",
      data,
    );
  }

  //company login
  getCompanyLogins(data) {
    return this.call("company-logins", "GET", data);
  }
  postCompanyLogins(type, data) {
    return this.call(`company-logins/${type}`, "POST", data);
  }
  putCompanyLogins(type, data) {
    return this.call(`company-logins/${type}/${data.uuid}`, "PUT", data);
  }
  putCompanyLoginDisableImport(uuid) {
    return this.call(`company-logins/disable-import/${uuid}`, "PUT");
  }
  putCompanyLoginImportData(company_login_uuid, data) {
    return this.call(
      `company-logins/import-data/${company_login_uuid}`,
      "PUT",
      data,
    );
  }
  postProcessAdGroups(data) {
    return this.call("company-logins/process-ad-groups", "POST", data);
  }
  postProcessAdCompany(data) {
    return this.call("company-logins/process-ad-company", "POST", data);
  }

  getIndentifications(data) {
    return this.call('request/identification', "GET", data)
  }

  getProtocols(data) {
    return this.call('request/protocol', "GET", data)
  }

  getPublicUsers(data) {
    return this.call("users/public", "GET", data);
  }
  putAdGroupsUpdateMany(data) {
    return this.call(`company-logins/ad-groups/update-many`, "PUT", data);
  }

  getGroups(data) {
    return this.call("groups", "GET", {
      ...data,
      module: [process.env.VUE_APP_API_MODULE],
    });
  }


}
const appApi = new ApiClient();

export default appApi;
